<div class="container-fluid">

  <h4 id="upper">Paramètre machines </h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div>
            <!--  -->
            <a (click)="openModal()" title="Cliquez ici pour ajouter une machine" style="background-color:#578D63 ;"
              href="javascript:void(0);" class="btn btn-success mb-2" id="gras">
              <i class="mdi mdi-plus me-2"></i> Ajouter
            </a>&nbsp;
          </div>
          <div class="row mb-md-2">


            <!-- End search -->
          </div>
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                  style="border-color: #578D63;">
                  <th scope="col" class="ps-0">Nom machine</th>
                  <th scope="col" class="text-center">Type machine</th>
                  <th scope="col" class="text-center">État machine</th>
                  <!-- <th scope="col" class="text-center">Conditions location</th> -->
                  <th scope="col" class="text-center">Montant location</th>
                  <th scope="col" class="text-center">Photo</th>
                  <th scope="col" class="text-center">Disponibilité</th>
                  <th scope="col" colspan="2" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr *ngFor="let item of paginatedItems">
                  <th scope="row" class="ps-0 fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item.nom}} &nbsp;</span>
                  </th>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item?.types_machine?.nom}} &nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item?.etats_machine?.nom}}&nbsp;</span>
                  </td>
                  <!-- <td class="text-center fw-medium">
        <span class="table-link1 text-truncate d-block">{{item.condition_location}}&nbsp;</span>
      </td> -->
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item.montant}} &nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block"><img [src]="item.image" style="width: 152px;"
                        alt=""> &nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">
                    <!-- Indicateur de disponibilité avec cercle coloré -->
                    <span class="disponibility-indicator"
                      [ngClass]="{'disponible': item.disponible === true, 'non-disponible': item.disponible === false}"
                      [title]="item.disponible ? 'Disponible' : 'Non disponible'">
                    </span>
                  </td>
                  <td>
                    <a (click)="rendreDisponibleMachine(item)" style="cursor: pointer;" class="me-3"
                      [title]="item.disponible ? 'Machine disponible' : 'Rendre disponible la machine'">

                      <i class="mdi font-size-18" [ngClass]="{
       'mdi-check-circle text-success': item.disponible,
       'mdi-close-circle text-danger': !item.disponible
     }">
                      </i>

                    </a>
                    <a (click)="editOpenModal(item)" title="" style="cursor: pointer;" class="me-3 text-primary"
                      v-b-tooltip.hover title="Cliquez ici pour modifier une machine">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a (click)="confirmSuppression(item)" title="Cliquez ici pour supprimer une machine"
                      href="javascript:void(0);" class="text-danger" v-b-tooltip.hover
                      title="Cliquez ici pour supprimer une machine">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a> &nbsp;&nbsp;
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="d-flex justify-content-center mt-4" *ngIf="isLoading === true">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Chargement en cours...</h5>
                <div class="loader4"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- Message d'erreur -->
        <div *ngIf="hasError && !isLoading" class="text-center my-5">
          <i class="bi bi-exclamation-circle text-danger" style="font-size: 2rem;"></i>
          <p class="text-danger">{{ errorMessage }}</p>
          <button class="btn btn-primary" (click)="getParametrage()"><i class="pi pi-refresh"
              style="font-size: 2rem"></i>
          </button>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center mt-4">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>
    </div>


  </div>
  <p-toast position="top-center" />
  <p-confirmDialog />